'use client';

import {useParams} from 'next/navigation';

export const useCurrentLiveEventSlug = () => {
    return useParams<{slug: string}>().slug;
};
